import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e051401e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "new-refund" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Nueva devolución ")

import { IonButton } from '@ionic/vue'
import { useRoute } from 'vue-router'

import router from '@/router'
import { useRefundStore } from '@/store/refund'

import IonicIcon from '@/components/IonicIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewRefundButton',
  setup(__props) {

const refundStore = useRefundStore()
const route = useRoute()

const onNewRefund = async () => {
  refundStore.$patch({
    originPage: route.fullPath,
    newRefund: {
      id: null,
      finished: false,
      numdev: null,
      datetime: null,
      clientCode: null,
      clientName: null,
      type: null,
      packageQuantity: null,
      tagCodes: [],
      email: null,
      authorisation: null,
      wholesaler: null,
      observation: null,
      comment: null,
      lines: [],
      clientSignature: {
        filename: null,
        base64: null
      },
      userSignature: {
        filename: null,
        base64: null
      },
      attachment1: {
        filename: null,
        base64: null
      },
      attachment2: {
        filename: null,
        base64: null
      },
      attachment3: {
        filename: null,
        base64: null
      }
    }
  })

  await router.push({ name: 'new-refund-general-data', replace: true })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonButton), { onClick: onNewRefund }, {
      default: _withCtx(() => [
        _createVNode(IonicIcon, {
          color: "",
          icon: "addOutline"
        }),
        _hoisted_2
      ]),
      _: 1
    })
  ]))
}
}

})